var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _linearGradient4, _path4, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _linearGradient5, _path5, _linearGradient6, _circle, _linearGradient7, _circle2, _linearGradient8, _circle3, _linearGradient9, _circle4, _linearGradient0, _circle5, _linearGradient1, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Fence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAa",
    x1: 13.873,
    x2: 32.248,
    y1: 41.283,
    y2: 6.724,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AcSn4QlJX8rdYcH53EzfAa)",
    d: "M27,41.001h-6c-0.552,0-1-0.448-1-1V11.775c0-0.397,0.118-0.784,0.339-1.114l2.829-4.218 c0.397-0.592,1.267-0.592,1.664,0l2.829,4.218C27.882,10.991,28,11.379,28,11.775V40C28,40.553,27.552,41.001,27,41.001z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAb",
    x1: 0.873,
    x2: 19.248,
    y1: 41.283,
    y2: 6.724,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AcSn4QlJX8rdYcH53EzfAb)",
    d: "M14,41H8c-0.552,0-1-0.448-1-1V11.775c0-0.397,0.118-0.784,0.339-1.114l2.829-4.218 c0.397-0.592,1.267-0.592,1.664,0l2.829,4.218C14.882,10.99,15,11.378,15,11.775V40C15,40.552,14.552,41,14,41z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAc",
    x1: 26.649,
    x2: 45.205,
    y1: 41.704,
    y2: 6.806,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AcSn4QlJX8rdYcH53EzfAc)",
    d: "M40,41.001h-6c-0.552,0-1-0.448-1-1V11.775c0-0.397,0.118-0.784,0.339-1.114l2.829-4.218 c0.397-0.592,1.267-0.592,1.664,0l2.829,4.218C40.882,10.991,41,11.379,41,11.775V40C41,40.553,40.552,41.001,40,41.001z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 7,
    y: 13,
    opacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 20,
    y: 13,
    opacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 33,
    y: 13,
    opacity: 0.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    x: 7,
    y: 13.5,
    opacity: 0.07
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    x: 20,
    y: 13.5,
    opacity: 0.07
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    x: 33,
    y: 13.5,
    opacity: 0.07
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAd",
    x1: 18.628,
    x2: 30.54,
    y1: 40.102,
    y2: 17.7,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d67526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#c86b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#b35b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#a5510c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a14e0a"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AcSn4QlJX8rdYcH53EzfAd)",
    d: "M43,22.001H5c-1.105,0-2-0.895-2-2v-4c0-1.105,0.895-2,2-2h38c1.105,0,2,0.895,2,2v4 C45,21.105,44.105,22.001,43,22.001z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 7,
    y: 26,
    opacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 20,
    y: 26,
    opacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    x: 33,
    y: 26,
    opacity: 0.05
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    x: 7,
    y: 26.5,
    opacity: 0.07
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    x: 20,
    y: 26.5,
    opacity: 0.07
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    x: 33,
    y: 26.5,
    opacity: 0.07
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAe",
    x1: 18.744,
    x2: 30.656,
    y1: 26.884,
    y2: 4.481,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d67526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#c86b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#b35b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#a5510c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a14e0a"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AcSn4QlJX8rdYcH53EzfAe)",
    d: "M43,35.001H5c-1.105,0-2-0.895-2-2v-4c0-1.105,0.895-2,2-2h38c1.105,0,2,0.895,2,2v4 C45,34.105,44.105,35.001,43,35.001z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAf",
    x1: 36.936,
    x2: 37.156,
    y1: 32.745,
    y2: 23.277,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 18,
    r: 2,
    fill: "url(#AcSn4QlJX8rdYcH53EzfAf)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAg",
    x1: 23.943,
    x2: 24.163,
    y1: 32.443,
    y2: 22.975,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 2,
    fill: "url(#AcSn4QlJX8rdYcH53EzfAg)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAh",
    x1: 10.95,
    x2: 11.17,
    y1: 32.141,
    y2: 22.673,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 18,
    r: 2,
    fill: "url(#AcSn4QlJX8rdYcH53EzfAh)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAi",
    x1: 36.936,
    x2: 37.156,
    y1: 19.745,
    y2: 10.277,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 31,
    r: 2,
    fill: "url(#AcSn4QlJX8rdYcH53EzfAi)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAj",
    x1: 23.943,
    x2: 24.163,
    y1: 19.443,
    y2: 9.975,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 31,
    r: 2,
    fill: "url(#AcSn4QlJX8rdYcH53EzfAj)"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "AcSn4QlJX8rdYcH53EzfAk",
    x1: 10.95,
    x2: 11.17,
    y1: 19.141,
    y2: 9.673,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc6c17"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 31,
    r: 2,
    fill: "url(#AcSn4QlJX8rdYcH53EzfAk)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Fence);
export default __webpack_public_path__ + "static/media/icons8-fence.63c8abddbcfee0864b2c67d620444234.svg";
export { ForwardRef as ReactComponent };